import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  heroContent: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      left: 50,
      top: 60,
    }
  },
  stagingQuoteButton: {
    width:'100%',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('md')]: {
      width: 260
    }
  },
  financeContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      width: 200,
    }
  },
  financeContentFirstRow: {
    fontSize: 36,
    fontWeight: 450,
    [theme.breakpoints.up('md')]: {
      fontSize: 48,
    }
  },
  financeContentSecondRow: {
    fontSize: 14,
    opacity: 0.6,
    [theme.breakpoints.up('md')]: {
      fontSize: 26,
    }
  },
  financeContentDivider: {
    color: theme.palette.common.black,
    border: '1px solid'
  },
  affirmPlusGHContainer: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 220
    },
    [theme.breakpoints.up('xl')]: {
      width: '100%'
    }
  },
  affirmPlusGHTitle: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 0,
    lineHeight: 1.2,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(3),
      fontSize: 28,
      height: 80
    }
  },
  affirmPlusGHContent: {
    fontSize: 14,
    opacity: 0.6,
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    }
  }
}));
